<template>
  <div>
    <nav aria-label='breadcrumb'>
      <ol class='breadcrumb'>
        <li class='breadcrumb-item'><a href='#'>{{translations('navbar.sale_management')}}</a></li>
        <li class='breadcrumb-item active' aria-current='page'>{{translations('estimate.archive_estimate')}}</li>
      </ol>
    </nav>
    <section class='container-fluid main-container'>
      <div class='form-inline mb-4 justify-content-between'>
        <div class="d-flex flex-wrap align-items-center">
          <div class='form-group mr-2'>
            <router-link class='btn btn-primary' to='new-estimates'>{{translations('common.addition')}}</router-link>
          </div>
          <div class='form-group mr-1'>
            <input id='dtSearch' type='text' class='form-control' v-model='dtSearch' :placeholder="translations('common.keyword_search')">
          </div>
          <div class="form-group mr-3">
          <v-select
            :value="clients.find(c => c.id === client_id) || ''"
            :options="clients"
            label="name"
            :placeholder="translations('estimate.supplier')"
            :id="client_id"
            @input="changedClients">
          </v-select>
          </div>
          <div class="form-group mr-3 d-flex align-items-center flex-wrap">
            <span class="text-nowrap mr-1">{{translations('common.period')}}</span>
<!--            <input v-model="dateFrom" type="date" class="form-control" @blur='triggerDateFilter("dateFrom")' @focus="tempDateField = dateFrom">-->
            <input v-model="dateFrom" type="date" class="form-control">
            <span class="mr-1 ml-1">〜</span>
<!--            <input v-model="dateTo" type="date" class="form-control" @blur='triggerDateFilter("dateTo")' @focus="tempDateField = dateTo">-->
            <input v-model="dateTo" type="date" class="form-control">
          </div>
          <div class='form-group'>
            <div class='form-check'>
              <input class='form-check-input' pointer type='checkbox' value='' v-model='isShowReceivedOrder' ref='defaultCheck1' id='defaultCheck1'>
              <label class='form-check-label' pointer for='defaultCheck1'>
                {{translations('estimate.view_past_quotes_too')}}
              </label>
            </div>
          </div>
          <div class="form-group ml-2">
            <div class="form-check">
              <input v-model="displayAll" class="form-check-input pointer-clickable" id="displayAll" type="checkbox" value="" >
              <label class="form-check-label pointer-clickable" for="displayAll">
                {{translations('common.display_all')}}
              </label>
            </div>
          </div>
          <div class="form-group ml-2">
            <button class="btn btn-primary btn-sm" type="button" @click="submitSearch">{{translations('common.search')}}</button>
          </div>
        </div>
        <div class="form-group" style="margin-top: 1px">
          <button class='btn btn-primary btn-sm' type="button" @click="exportCsv">{{translations('common.csv_export')}}</button>
        </div>
      </div>
      <div class='table-scroll mb-4'>
        <v-data-table
          class="table table-striped table-hover table-1500 table-clickable"
          item-key="name"
          :headers="translatedHeaders"
          :items="estimates"
          :options.sync="options"
          :server-items-length="totalCount"
          hide-default-footer
          @page-count="pageCount = $event"
        >
          <template v-slot:body="{ items }">
            <tbody class="nowrap">
              <tr v-for='(estimate, i) in items' :id='"tr"+estimate.id' :key='i' v-on:click='openEstimate(estimate)' :data-href='estimate.estimate_id' :class="{ 'table-danger': parseInt(estimate.estimation_status) === 3 }">
                <input type="hidden" :value="estimate.estimate_id = estimate.id">
                <td>{{i + 1}}</td>
                <td><span class='badge' :class="statuses[estimate.estimation_status].badge">{{ statuses[estimate.estimation_status].ja }}</span></td>
                <td>{{ $invoiceTools.formatDate(estimate.estimated_at) }}</td>
                <td>{{ estimate.name }}</td>
                <td>{{ estimate.estimate_number }}</td>
                <td>{{ estimate.client_name }}</td>
                <td><ul><li v-for='(val, ii) in estimate.details' :key='ii'>{{ val.jan_code }}</li></ul></td>
                <td><ul><li v-for='(val, i2) in estimate.details' :key='i2'>{{ val.type_number }}</li></ul></td>
                <td class="right"><ul><li v-for='(val, i4) in estimate.details' :key='i4'>{{ Number(val.quantity).toLocaleString() }}</li></ul></td>
                <td class="right"><ul><li v-for='(val, i3) in estimate.details' :key='i3'>{{ Number(val.unit_price).toLocaleString() }}</li></ul></td>
                <td class="right">{{ Number(estimate.total_amount).toLocaleString() }}</td>
                <td>{{ estimate.destination_name }}</td>
                <td><DivisionTypeText :division_type="estimate.division_type" :labelDefault="null" /></td>
                <td><ul><li v-for='(val, i5) in estimate.details' :key='i5'>{{ val.remarks }}</li></ul></td>
              </tr>
            </tbody>
          </template>
        </v-data-table>
      </div>
      <v-pagination v-model="page" :length="pageCount" :total-visible="11"></v-pagination>
    </section>
    <vue-element-loading :active="isSearching" :is-full-screen="true"/>
  </div>
</template>

<script>
import VueElementLoading from 'vue-element-loading'
import DivisionTypeText from '@/components/orders/DivisionTypeText'
import { mapState } from 'vuex'
import { saveAs } from 'file-saver'
import Papa from 'papaparse'
import encoding from 'encoding-japanese'
import {DivisionType} from "@/constants";

export default {
  name: 'ArchiveEstimates',
  prop: {},
  components: {
    VueElementLoading,
    DivisionTypeText
  },
  data () {
    console.log(this.$util.numberSymbolFormatter(123456))
    console.log(this.$util.numberSymbolFormatter(19567))
    return {
      estimates: [],
      statuses: [
        { 'id': 0, 'en': 'None', ja: '該当なし', 'badge': '' },
        { 'id': 1, 'en': 'Pending', ja: '未受注', 'badge': 'badge-light' },
        { 'id': 2, 'en': 'Succesful', ja: '受注済み', 'badge': 'badge-success' },
        { 'id': 3, 'en': 'Failed', ja: '失注', 'badge': 'badge-danger' }
      ],
      client_id: 0,
      dtSearch: '',
      isSearching: false,
      isShowReceivedOrder: false,
      isEmpty: false,
      isEmptyMsg: '',
      dateTo: '',
      dateFrom: '',
      // tempDateField: '',
      page: 1,
      pageCount: 0,
      totalCount: 0,
      options: {
        page: 1,
        itemsPerPage: 10,
        sortBy: [],
        sortDesc: [],
        groupBy: [],
        groupDesc: [],
        multiSort: false,
        mustSort: false
      },
      displayAll: false
    }
  },

  computed: {
    ...mapState(['currentLanguage']),
    clients () {
      return this.$store.getters['Master/getBillTo']
    },
    translatedHeaders () {
      const headers = [
        { text: 'No', sortable: false },
        { text: 'estimate.estimation_status', value: 'estimation_status' },
        { text: 'estimate.estimated_at', value: 'estimated_at' },
        { text: 'estimate.name', value: 'name' },
        { text: 'estimate.estimate_number', value: 'estimate_number' },
        { text: 'estimate.younosuke_company_name', value: 'younosuke_company_name' },
        { text: 'estimate.jan_code', value: 'jan_code' },
        { text: 'estimate.model', value: 'model' },
        { text: 'estimate.quantity', value: 'quantity' },
        { text: 'estimate.unit_price', value: 'unit_price' },
        { text: 'estimate.total_amount', value: 'total_amount' },
        { text: 'estimate.destination_name', value: 'destination_name' },
        { text: 'estimate.summary', value: 'remarks' }
      ]
      return headers.map(header => ({
        ...header,
        text: this.translations(header.text)
      }))
    }
  },

  watch: {
    // client_id () {
    //   this.submitSearch()
    // },
    page () {
      this.getFilterdList()
    },
    options: {
      handler () {
        let visitCount = Number(localStorage.getItem('visitCountEstimates')) || 0
        if (visitCount > 0) {
          this.initList()
        }
      },
      deep: true
    }
  },

  created () {
    this.$store.dispatch('Master/checkBillTo')
    let storedFilter = this.$storage.get('ArchiveEstimatesParam')
    if (storedFilter) {
      this.dtSearch = storedFilter.search
      this.isShowReceivedOrder = storedFilter.show_received_order
      this.client_id = storedFilter.client_id ? parseInt(storedFilter.client_id) : 0
      this.dateFrom = storedFilter.start_at
      this.dateTo = storedFilter.end_at
      this.options.sortBy = storedFilter.orderbys
      this.options.sortDesc = storedFilter.is_descs
    }
  },

  methods: {
    translations (key) {
      const language = require(`@/locales/${this.currentLanguage}.json`)
      const keys = key.split('.')
      let value = language

      for (const k of keys) {
        value = value[k]
        if (!value) break
      }

      return value || key
    },

    openEstimate (estimate) {
      this.$router.push({ name: 'single-estimate', query: { estimate_id: estimate.id } })
    },

    getFilterTxt (obj, input, output, _default) {
      if (input) {
        if (input === 0) return _default
        return this.$invoiceTools.getObjPropsById(obj, input, output)
      }
      return _default
    },

    // changeSearch (e) {
    //   this.$storage.set('ArchiveEstimates:dtSearch', e.target.value) // KEEP KEYWORD
    //   this.initList()
    // },

    // triggerDateFilter (source) {
    //   if (source === 'dateFrom' && this.dateFrom !== this.tempDateField) {
    //     this.initList()
    //   }
    //
    //   if (source === 'dateTo' && this.dateTo !== this.tempDateField) {
    //     this.initList()
    //   }
    // },

    initList () {
      if (this.page !== 1) {
        this.page = 1
      } else {
        this.getFilterdList()
      }
    },

    getFilterdList (field, val) {
      if (this.isSearching) {
        return
      }

      if (this.displayAll) {
        this.$storage.set('estimate_display_all', this.displayAll)
        this.options.itemsPerPage = -1 // DISPLAY ALL
      } else {
        this.options.itemsPerPage = 10 // DISPLAY 10 ROWS
      }

      this.isSearching = true

      const offset = (this.page - 1) * this.options.itemsPerPage
      const limit = this.options.itemsPerPage
      const orderbys = JSON.parse(JSON.stringify(this.options.sortBy))
      const isDescs = JSON.parse(JSON.stringify(this.options.sortDesc))

      // let search = this.dtSearch
      // if (this.client_id) {
      //   search = ''
      // }

      let params = {
        show_received_order: this.isShowReceivedOrder,
        client_id: this.client_id,
        start_at: (this.dateFrom) ? this.dateFrom : '',
        end_at: (this.dateTo) ? this.dateTo : '',
        offset: offset,
        limit: limit,
        orderbys: orderbys,
        is_descs: isDescs,
        search: this.dtSearch
      }

      this.$storage.set('ArchiveEstimatesParam', params)
      console.log('ArchiveEstimates:getFilterdList: ', params)

      this.$http.post(this.$api_url.estimates_list, params).then(response => {
        const result = response.data
        console.log('ArchiveEstimates:getFilterdList: ', result)
        if (result.status === true) {
          this.isEmpty = false
          this.isEmptyMsg = ''
          this.estimates = result.list
          localStorage.setItem('visitCountEstimates', this.estimates.length)
          this.totalCount = Number(result.total_count)
        } else {
          this.estimates = []
          this.$toastr.error(result.message, 'エラー')
        }
      }).catch(error => {
        console.log('ArchiveEstimates:API:getFilterdList: error: ', error)
        this.isEmpty = true
        this.isEmptyMsg = 'エラーのため失敗しました。ご確認後、再試行してください。'
        this.$toastr.error(this.isEmptyMsg, 'エラー')
      }).finally(() => {
        this.isSearching = false
        this.$nextTick(() => {
          this.$vuetify.goTo('.table-scroll', { duration: 0 })
        })
      })
    },

    changedClients (event) {
      if (!event) {
        this.client_id = 0
        return
      }
      this.client_id = event.id
    },

    submitSearch () {
      this.initList()
    },

    exportCsv () {
      if (this.isSearching) {
        return
      }

      this.isLoading = true
      let params = {
        show_received_order: this.isShowReceivedOrder,
        client_id: this.client_id,
        start_at: (this.dateFrom) ? this.dateFrom : '',
        end_at: (this.dateTo) ? this.dateTo : '',
        search: this.dtSearch
      }

      return this.$http.post(this.$api_url.estimates_csv, params).then(response => {
        const result = response.data
        if (result.status) {
          this.saveCsv_(result.list)
        }
      }).catch(e => {
        this.isEmpty = true
        this.isEmptyMsg = 'エラーのため失敗しました。ご確認後、再試行してください。'
        this.$toastr.error(this.isEmptyMsg, 'エラー')
      }).finally(() => {
        this.isLoading = false
      })
    },

    saveCsv_ (list) {
      const data = []

      list.forEach(item => {
        const divisionTypeObj = DivisionType.find(type => type.value === item.division_type)

        item.details.forEach(detail => {
          data.push([
            this.statuses[item.estimation_status].ja,
            item.estimated_at,
            item.name,
            item.estimate_number,
            item.client_name,
            detail.jan_code,
            detail.type_number,
            detail.quantity,
            detail.unit_price,
            item.total_amount,
            item.destination_name,
            divisionTypeObj ? divisionTypeObj.label : ''
          ])
        })
      })

      let csv = ''
      csv = Papa.unparse({
        fields: [
          this.translations('estimate.estimation_status'),
          this.translations('estimate.estimated_at'),
          this.translations('estimate.name'),
          this.translations('estimate.estimate_number'),
          this.translations('estimate.younosuke_company_name'),
          this.translations('estimate.jan_code'),
          this.translations('estimate.model'),
          this.translations('estimate.quantity'),
          this.translations('estimate.unit_price'),
          this.translations('estimate.total_amount'),
          this.translations('estimate.destination_name'),
          this.translations('estimate.summary')
        ],
        data: data
      })

      const unicodeList = encoding.stringToCode(csv)
      const sjisArray = encoding.convert(unicodeList, 'SJIS', 'UNICODE')
      const uInt8List = new Uint8Array(sjisArray)
      const content = new Blob([uInt8List], { type: 'text/csv' })

      const d = new Date()
      const filename = this.translations('estimate.estimate_') + d.getFullYear() +
        ('0' + (d.getMonth() + 1)).slice(-2) +
        ('0' + d.getDate()).slice(-2) + '_' +
        ('0' + d.getHours()).slice(-2) +
        ('0' + d.getMinutes()).slice(-2) +
        ('0' + d.getSeconds()).slice(-2) + '.csv'

      saveAs(content, filename)

      this.isLoading = false
    }
  }
}
</script>
